export default __webpack_public_path__ + "media/images/react_icons/arrow-down2-aa3124800e40fd025ae606d49a4dc5c0.svg";